var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-table-column',{attrs:{"prop":"updated_at","sortable":"","label":"Módosítva"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n    "+_vm._s(_vm._f("dateTime")(scope.row.updated_at))+"\n  ")]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }